import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import { IoFilter, IoFilterOutline, IoInformationCircleOutline } from "react-icons/io5";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import VuiBox from "components/ui/VuiBox";
import VuiTypography from "components/ui/VuiTypography";
import { COMPONENT_STYLES } from "utils/designTokens";

const TableHeaderWithFilters = ({
  title,
  tooltipText,
  onFilterClick,
  onExpandClick,
  hasActiveFilters = false,
  filtersAnchorEl,
  showFilters = true,
  showExpand = true,
}) => {
  return (
    <VuiBox pb={0}>
      <VuiBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={0.5}
        flexWrap="wrap"
        sx={{ gap: 1, rowGap: 0.5 }}
      >
        <VuiBox
          display="flex"
          alignItems="center"
          sx={{
            minWidth: 0,
            flex: "1 1 auto",
            pr: { xs: 0, sm: 1 },
          }}
        >
          <VuiTypography
            variant="h6"
            color="white"
            fontWeight="medium"
            sx={{
              minWidth: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {title}
          </VuiTypography>
          {tooltipText && (
            <Tooltip
              title={
                <VuiTypography
                  variant="button"
                  color="white"
                  fontWeight="regular"
                  sx={{
                    fontSize: "11px",
                    fontFamily: "Sora, sans-serif",
                  }}
                >
                  {tooltipText}
                </VuiTypography>
              }
              placement="top"
              arrow
            >
              <div style={{ display: "inline-block", cursor: "pointer" }}>
                <VuiBox
                  component={IoInformationCircleOutline}
                  size="14px"
                  color="white"
                  ml={0.5}
                  sx={{ opacity: 0.7 }}
                />
              </div>
            </Tooltip>
          )}
        </VuiBox>
        <VuiBox display="flex" alignItems="center" gap={1} flexShrink={0}>
          {showFilters && (
            <IconButton onClick={onFilterClick} size="small" sx={COMPONENT_STYLES.iconButton}>
              {filtersAnchorEl ? <IoFilter /> : <IoFilterOutline />}
            </IconButton>
          )}
          {showExpand && (
            <IconButton onClick={onExpandClick} size="small" sx={COMPONENT_STYLES.iconButton}>
              <AspectRatioIcon />
            </IconButton>
          )}
        </VuiBox>
      </VuiBox>
    </VuiBox>
  );
};

export default TableHeaderWithFilters;
